import { customInstance } from "@/lib/api/client";
import type { ExportJobStatusSchema } from "@/lib/api/model";

import type { ExportJobAdapter } from "./types";

/** Profile and Insights exports: `POST /api/exports`, polled at `GET /api/export/{id}`. */
export const profileExportAdapter: ExportJobAdapter<ExportJobStatusSchema> = {
  queryKey: (jobId) => ["export-job", jobId],
  fetchStatus: (jobId) =>
    customInstance<ExportJobStatusSchema>(`/api/export/${jobId}`),
  read: (status) => ({
    status:
      status.status === "ready" || status.status === "failed"
        ? status.status
        : "pending",
    url: status.download_url ?? null,
    error: status.error ?? null,
  }),
  readyAction: "download",
  invalidates: [["billing", "credits"], ["export-history"], ["export-estimate"]],
};
